// src/components/SecuredImage.tsx
import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { getKeyFromLocalStorage } from 'utils/constant';

interface SecuredImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt?: string;
}

const SecuredImage: React.FC<SecuredImageProps> = ({ src, alt = '' }) => {
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!src) return;

    let objectUrl: string | null = null;

    const fetchImage = async () => {
      try {
        const appId = getKeyFromLocalStorage('appId');
        const appKey = getKeyFromLocalStorage('appKey');
        const dbId = getKeyFromLocalStorage('dbId');
        const dbKey = getKeyFromLocalStorage('dbKey');

        const response = await fetch(
          `${
            localStorage.getItem('url') ?? process.env.REACT_APP_CLUSTER_DB_API
          }${src}`,
          {
            headers: {
              'X-App-Id': appId ?? '',
              'X-App-Key': appKey ?? '',
              'X-App-Db': dbId ?? '',
              'X-App-Db-Key': dbKey ?? '',
            },
          }
        );

        if (!response.ok) {
          throw new Error(`Failed to fetch image: ${response.status}`);
        }

        const imageBlob = await response.blob();
        objectUrl = URL.createObjectURL(imageBlob);
        setImageUrl(objectUrl);
      } catch (err: unknown) {
        // empty
      }
    };

    fetchImage();

    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [src]);

  return (
    <Box
      component='img'
      src={imageUrl ?? ''}
      sx={{
        width: 120,
        height: 100,
        objectFit: 'cover',
        border: '1px solid #000000',
      }}
      alt={alt}
    />
  );
};

export default SecuredImage;
